import {ErrorProcessor, LOAD_ERROR_MSG} from '../types'
import {getLoadErrorSrc} from '../utils'

export const processResourceFails: ErrorProcessor = (error, scope) => {
  const loadErrorSrc = getLoadErrorSrc(error)

  if (!loadErrorSrc) {
    return error
  }

  switch (error.message) {
    case LOAD_ERROR_MSG.SCRIPT:
      if (loadErrorSrc.includes('-extension://')) {
        return scope.updateError({
          service: 'extension',
          level: Ya.Rum.ERROR_LEVEL.INFO,
        })
      }
      break
    case LOAD_ERROR_MSG.IMG:
      if (loadErrorSrc.includes('//ya-authproxy.taxi.yandex.ru/3.0/getimage')) {
        return scope.updateError({service: 'authproxy'})
      }
      break
  }

  return error
}
